import {
    CLEAR_CONTENT,
    GET_AGREEMENT_ERROR,
    GET_AGREEMENT_INIT,
    GET_AGREEMENT_SUCCESS,
    GET_BUSINESS_PROFILE_DESCRIPTION_ERROR,
    GET_BUSINESS_PROFILE_DESCRIPTION_INIT,
    GET_BUSINESS_PROFILE_DESCRIPTION_SUCCESS,
    GET_BUSINESS_PROFILE_DIMENSIONS_ERROR,
    GET_BUSINESS_PROFILE_DIMENSIONS_INIT,
    GET_BUSINESS_PROFILE_DIMENSIONS_SUCCESS,
    GET_BUSINESS_PROFILE_FLEXIBILITY_ERROR,
    GET_BUSINESS_PROFILE_FLEXIBILITY_INIT,
    GET_BUSINESS_PROFILE_FLEXIBILITY_SUCCESS,
    GET_CONSENT_ERROR,
    GET_CONSENT_INIT,
    GET_CONSENT_SUCCESS,
    GET_CONTENT_TYPE_ERROR,
    GET_CONTENT_TYPE_INIT,
    GET_CONTENT_TYPE_SUCCESS,
    GET_DEV_TALK_AGENDA_ERROR,
    GET_DEV_TALK_AGENDA_INIT,
    GET_DEV_TALK_AGENDA_SUCCESS,
    GET_DEV_TALK_PREPARATION_ERROR,
    GET_DEV_TALK_PREPARATION_INIT,
    GET_DEV_TALK_PREPARATION_SUCCESS,
    GET_LOGIC_REPORT_SCORE_ERROR,
    GET_LOGIC_REPORT_SCORE_INIT,
    GET_LOGIC_REPORT_SCORE_SUCCESS,
    GET_LOGIC_TEST_RESULT_CONTENT_ERROR,
    GET_LOGIC_TEST_RESULT_CONTENT_INIT,
    GET_LOGIC_TEST_RESULT_CONTENT_SUCCESS,
    GET_PAGES_ERROR,
    GET_PAGES_INIT,
    GET_PAGES_SUCCESS,
    GET_PERSONALITY_ERROR,
    GET_PERSONALITY_INIT,
    GET_PERSONALITY_IRT_FACET_CONTENT_ERROR,
    GET_PERSONALITY_IRT_FACET_CONTENT_INIT,
    GET_PERSONALITY_IRT_FACET_CONTENT_SUCCESS,
    GET_PERSONALITY_RESULT_ERROR,
    GET_PERSONALITY_RESULT_INIT,
    GET_PERSONALITY_RESULT_SUCCESS,
    GET_PERSONALITY_SUCCESS,
    GET_PERSONALITY_V2_ERROR,
    GET_PERSONALITY_V2_INIT,
    GET_PERSONALITY_V2_SUCCESS
} from './constants';


export const initialContent = {
    personalityResult: {
        loading: false,
        error: '',
        data: null
    },
    personalityTest: {
        loading: false,
        error: '',
        data: {}
    },
    personalityTestV2: {
        loading: false,
        error: '',
        data: {}
    },
    pages: {
        loading: false,
        error: '',
        data: {}
    },
    agreement: {
        loading: false,
        error: '',
        data: {}
    },
    consent: {
        loading: false,
        error: '',
        data: {}
    },
    developmentTalkAgenda: {
        loading: false,
        error: '',
        data: {}
    },
    developmentTalkPreparation: {
        loading: false,
        error: '',
        data: {}
    },
    businessProfileDescription: {
        loading: false,
        error: '',
        data: {}
    },
    businessProfileDimensions: {
        loading: false,
        error: '',
        data: {}
    },
    businessProfileFlexibility: {
        loading: false,
        error: '',
        data: {}
    },
    personalityIrtFacet: {
        loading: false,
        error: null,
        data: {}
    },
    logicTestResult: {
        loading: false,
        error: null,
        data: {}
    },
    logicReportScore: {
        loading: false,
        error: null,
        data: {}
    }
};

export function content(state = initialContent, action) {

    switch (action.type) {
        case CLEAR_CONTENT:
            return Object.assign({}, initialContent);
        case GET_PERSONALITY_RESULT_INIT:
            return Object.assign({}, state, {
                personalityResult: {
                    loading: true,
                    error: null,
                    data: null
                }
            });
        case GET_PERSONALITY_RESULT_ERROR:
            return Object.assign({}, state, {
                personalityResult: {
                    loading: false,
                    error: action.error,
                    data: null
                }
            });
        case GET_PERSONALITY_RESULT_SUCCESS:
            return Object.assign({}, state, {
                personalityResult: {
                    loading: false,
                    error: null,
                    data: action.data
                }
            });
        case GET_PERSONALITY_INIT:
            return Object.assign({}, state, {
                personalityTest: Object.assign({}, state.personalityTest, {
                    loading: true,
                    error: ''
                })
            });
        case GET_PERSONALITY_ERROR:
            return Object.assign({}, state, {
                personalityTest: Object.assign({}, state.personalityTest, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_PERSONALITY_SUCCESS:
            let contentFields = action.data.items.map(item => item.fields);
            // Group by 'key'-field (the field identifier)
            let contentFieldsGrouped = contentFields.reduce((acc, item) => {
                acc[item.key] = item;

                return acc;
            }, {});

            return Object.assign({}, state, {
                personalityTest: Object.assign({}, state.personalityTest, {
                    loading: false,
                    error: '',
                    data: contentFieldsGrouped
                })
            });
        case GET_PERSONALITY_V2_INIT:
            return Object.assign({}, state, {
                personalityTestV2: Object.assign({}, state.personalityTest, {
                    loading: true,
                    error: ''
                })
            });
        case GET_PERSONALITY_V2_ERROR:
            return Object.assign({}, state, {
                personalityTestV2: Object.assign({}, state.personalityTest, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_PERSONALITY_V2_SUCCESS:
            let contentFieldsV2 = action.data.items.map(item => item.fields);
            // Group by 'key'-field (the field identifier)
            let contentFieldsGroupedV2 = contentFieldsV2.reduce((acc, item) => {
                acc[item.key] = item;

                return acc;
            }, {});

            return Object.assign({}, state, {
                personalityTestV2: Object.assign({}, state.personalityTest, {
                    loading: false,
                    error: '',
                    data: contentFieldsGroupedV2
                })
            });
        case GET_PAGES_INIT:
            return Object.assign({}, state, {
                pages: Object.assign({}, state.pages, {
                    loading: true,
                    error: ''
                })
            });
        case GET_PAGES_ERROR:
            return Object.assign({}, state, {
                pages: Object.assign({}, state.pages, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_PAGES_SUCCESS:
            let fields = action.data.items.map(item => item.fields);
            let fieldsGrouped = fields.reduce((acc, item) => {
                acc[item.key] = item;

                return acc;
            }, {});

            return Object.assign({}, state, {
                pages: Object.assign({}, state.pages, {
                    loading: false,
                    error: '',
                    data: fieldsGrouped
                })
            });

        case GET_AGREEMENT_INIT:
            return Object.assign({}, state, {
                agreement: Object.assign({}, state.pages, {
                    loading: true,
                    error: ''
                })
            });
        case GET_AGREEMENT_ERROR:
            return Object.assign({}, state, {
                agreement: Object.assign({}, state.pages, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_AGREEMENT_SUCCESS:
            let agreementFieldsGrouped = action.data.items.reduce((acc, item) => {
                acc[item.fields.key] = {
                    revision: item.sys.revision,
                    ...item.fields
                };

                return acc;
            }, {});

            return Object.assign({}, state, {
                agreement: Object.assign({}, state.pages, {
                    loading: false,
                    error: '',
                    data: agreementFieldsGrouped
                })
            });
        case GET_CONSENT_INIT:
            return Object.assign({}, state, {
                consent: Object.assign({}, state.pages, {
                    loading: true,
                    error: ''
                })
            });
        case GET_CONSENT_ERROR:
            return Object.assign({}, state, {
                consent: Object.assign({}, state.pages, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_CONSENT_SUCCESS:
            const consentFieldsGrouped = action.data.items.reduce((acc, item) => {
                acc[item.fields.key] = {
                    revision: item.sys.revision.toString(),
                    ...item.fields
                };

                return acc;
            }, {});

            return Object.assign({}, state, {
                consent: Object.assign({}, state.pages, {
                    loading: false,
                    error: '',
                    data: consentFieldsGrouped
                })
            });
        case GET_DEV_TALK_AGENDA_INIT:
            return Object.assign({}, state, {
                developmentTalkAgenda: Object.assign({}, state.developmentTalkAgenda, {
                    loading: true,
                    error: ''
                })
            });
        case GET_DEV_TALK_AGENDA_ERROR:
            return Object.assign({}, state, {
                developmentTalkAgenda: Object.assign({}, state.developmentTalkAgenda, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_DEV_TALK_AGENDA_SUCCESS:
            const agendaFields = action.data.items.map(item => item.fields);
            // Group by 'key'-field (the field identifier), in this case 'agendaType'
            const agendaFieldsGrouped = agendaFields.reduce((acc, item) => Object.assign({}, acc, {[item.reviewResultStatus]: item}), {});

            return Object.assign({}, state, {
                developmentTalkAgenda: Object.assign({}, state.developmentTalkAgenda, {
                    loading: false,
                    error: '',
                    data: agendaFieldsGrouped
                })
            });
        case GET_DEV_TALK_PREPARATION_INIT:
            return Object.assign({}, state, {
                developmentTalkPreparation: Object.assign({}, state.developmentTalkPreparation, {
                    loading: true,
                    error: ''
                })
            });
        case GET_DEV_TALK_PREPARATION_ERROR:
            return Object.assign({}, state, {
                developmentTalkPreparation: Object.assign({}, state.developmentTalkPreparation, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_DEV_TALK_PREPARATION_SUCCESS:
            const preparationFields = action.data.items.map(item => item.fields);
            const preparationFieldsGrouped = preparationFields.reduce((acc, item) => Object.assign({}, acc, {[item.reviewResultStatus]: item}), {});

            return Object.assign({}, state, {
                developmentTalkPreparation: Object.assign({}, state.developmentTalkPreparation, {
                    loading: false,
                    error: '',
                    data: preparationFieldsGrouped
                })
            });
        case GET_BUSINESS_PROFILE_DESCRIPTION_INIT:
            return Object.assign({}, state, {
                businessProfileDescription: Object.assign({}, state.businessProfileDescription, {
                    loading: true,
                    error: ''
                })
            });
        case GET_BUSINESS_PROFILE_DESCRIPTION_ERROR:
            return Object.assign({}, state, {
                businessProfileDescription: Object.assign({}, state.businessProfileDescription, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_BUSINESS_PROFILE_DESCRIPTION_SUCCESS:
            const businessProfileFields = action.data.items.map(item => item.fields);
            const businessProfileFieldsGrouped = businessProfileFields.reduce((acc, item) => Object.assign({}, acc, {[item.attribute]: item}), {});

            return Object.assign({}, state, {
                businessProfileDescription: Object.assign({}, state.businessProfileDescription, {
                    loading: false,
                    error: '',
                    data: businessProfileFieldsGrouped
                })
            });
        case GET_BUSINESS_PROFILE_DIMENSIONS_INIT:
            return Object.assign({}, state, {
                businessProfileDimensions: Object.assign({}, state.businessProfileDimensions, {
                    loading: true,
                    error: ''
                })
            });
        case GET_BUSINESS_PROFILE_DIMENSIONS_ERROR:
            return Object.assign({}, state, {
                businessProfileDimensions: Object.assign({}, state.businessProfileDimensions, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_BUSINESS_PROFILE_DIMENSIONS_SUCCESS:
            const businessProfileDimensionFields = action.data.items.map(item => item.fields);
            const businessProfileDimensionGrouped = businessProfileDimensionFields.reduce((acc, item) => Object.assign({}, acc, {[item.dimension]: item}), {});

            return Object.assign({}, state, {
                businessProfileDimensions: Object.assign({}, state.businessProfileDimensions, {
                    loading: false,
                    error: '',
                    data: businessProfileDimensionGrouped
                })
            });
        case GET_BUSINESS_PROFILE_FLEXIBILITY_INIT:
            return Object.assign({}, state, {
                businessProfileFlexibility: Object.assign({}, state.businessProfileFlexibility, {
                    loading: true,
                    error: ''
                })
            });
        case GET_BUSINESS_PROFILE_FLEXIBILITY_ERROR:
            return Object.assign({}, state, {
                businessProfileFlexibility: Object.assign({}, state.businessProfileFlexibility, {
                    loading: false,
                    error: action.error
                })
            });
        case GET_BUSINESS_PROFILE_FLEXIBILITY_SUCCESS:
            const businessProfileFlexibilityFields = action.data.items.map(item => item.fields);
            const businessProfileFlexibilityGrouped = businessProfileFlexibilityFields.reduce((acc, item) => Object.assign({}, acc, {[item.flexibilityLevel]: item}), {});

            return Object.assign({}, state, {
                businessProfileFlexibility: Object.assign({}, state.businessProfileFlexibility, {
                    loading: false,
                    error: '',
                    data: businessProfileFlexibilityGrouped
                })
            });
        case GET_PERSONALITY_IRT_FACET_CONTENT_INIT:
            return Object.assign({}, state, {
                personalityIrtFacet: {
                    loading: true,
                    error: null,
                    data: {}
                }
            });
        case GET_PERSONALITY_IRT_FACET_CONTENT_ERROR:
            return Object.assign({}, state, {
                personalityIrtFacet: {
                    loading: false,
                    error: action.error,
                    data: {}
                }
            });
        case GET_PERSONALITY_IRT_FACET_CONTENT_SUCCESS:
            return Object.assign({}, state, {
                personalityIrtFacet: {
                    loading: false,
                    error: null,
                    data: action.data
                }
            });
        case GET_LOGIC_TEST_RESULT_CONTENT_INIT:
            return Object.assign({}, state, {
                logicTestResult: {
                    loading: true,
                    error: null,
                    data: {}
                }
            });
        case GET_LOGIC_TEST_RESULT_CONTENT_ERROR:
            return Object.assign({}, state, {
                logicTestResult: {
                    loading: false,
                    error: action.error,
                    data: {}
                }
            });
        case GET_LOGIC_TEST_RESULT_CONTENT_SUCCESS:
            return Object.assign({}, state, {
                logicTestResult: {
                    loading: false,
                    error: null,
                    data: action.data
                }
            });
        case GET_CONTENT_TYPE_INIT:
            return Object.assign({}, state, {
                [action.contentType]: Object.assign({}, state[action.contentType], {
                    loading: true,
                    error: ''
                })
            });
        case GET_CONTENT_TYPE_ERROR:
            return Object.assign({}, state, {
                [action.contentType]: Object.assign({}, state[action.contentType], {
                    loading: false,
                    error: action.error
                })
            });
        case GET_CONTENT_TYPE_SUCCESS:
            return Object.assign({}, state, {
                [action.contentType]: Object.assign({}, state[action.contentType], {
                    loading: false,
                    error: '',
                    data: action.data.items.map(item => item.fields)
                })
            });
        case GET_LOGIC_REPORT_SCORE_INIT:
            return Object.assign({}, state, {
                logicReportScore: {
                    loading: true,
                    error: null,
                    data: null
                }
            });
        case GET_LOGIC_REPORT_SCORE_ERROR:
            return Object.assign({}, state, {
                logicReportScore: {
                    loading: false,
                    error: action.error,
                    data: null
                }
            });
        case GET_LOGIC_REPORT_SCORE_SUCCESS:
            return Object.assign({}, state, {
                logicReportScore: {
                    loading: false,
                    error: null,
                    data: action.data
                }
            });
        default:
            return state;
    }
}
